// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__OdbfO","title":"style_title__Ee6m7","footer":"style_footer__yHIPF"};